import { Divider, Flex, Text, Title } from "@mantine/core";
import classes from "../PayDashboard.module.css";

interface PayLabel {
    payDenomination: string;
    salesPay: number | null;
    surveyPay: number | null;
    otherPlansPay: number;
    otherPlansEnabled: boolean;
    isMissingData: boolean;
}
export function PayLabel({
    payDenomination,
    salesPay,
    surveyPay,
    otherPlansPay,
    otherPlansEnabled,
    isMissingData,
}: PayLabel) {
    const asterisk =
        salesPay === null || surveyPay === null || (otherPlansEnabled && otherPlansPay) == null || isMissingData
            ? "*"
            : "";
    const getPayValue = (pay: number | null): number => (pay === null ? 0 : pay);
    const sales = getPayValue(salesPay);
    const survey = getPayValue(surveyPay);
    const otherPlans = otherPlansEnabled ? getPayValue(otherPlansPay) : 0;

    return (
        <Flex gap={10}>
            <Flex direction="column" w="100%" pr="xxl">
                <Text
                    className={`${classes.payTotal} fs-mask`}
                >{`${payDenomination}${sales + survey + otherPlans}${asterisk}  `}</Text>
                <Title fw={400} fz="xs" c="dark.2" textWrap="nowrap">
                    Total projected earnings
                </Title>
            </Flex>
            <Divider size="sm" orientation="vertical" />
            <Flex direction="column" pl="xxl" w="100%">
                {isMissingData ? (
                    <Text fz="xs" c="dark.2">
                        <span className={classes.asterisk}>{"*"}</span> {"No incentive pay data found"}
                    </Text>
                ) : (
                    <>
                        <Text fz="xs" c="dark.2">
                            <span className={sales > 0 ? classes.fontAmount : classes.asterisk}>
                                {sales > 0 ? `${payDenomination}${sales}` : "*"}
                            </span>{" "}
                            {sales > 0 ? "VHDP" : "No sales data"}
                        </Text>
                        <Text fz="xs" c="dark.2">
                            <span className={survey > 0 ? classes.fontAmount : classes.asterisk}>
                                {survey > 0 ? `${payDenomination}${survey}` : "*"}
                            </span>{" "}
                            {survey > 0 ? "Surveys" : "No survey data"}
                        </Text>

                        {otherPlansEnabled && (
                            <Text fz="xs" c="dark.2">
                                <span className={otherPlans > 0 ? classes.fontAmount : classes.asterisk}>
                                    {otherPlans > 0 ? `${payDenomination}${otherPlans}` : "*"}
                                </span>{" "}
                                {otherPlansPay > 0 ? "Other plans" : "No other plans data"}
                            </Text>
                        )}
                    </>
                )}
            </Flex>
        </Flex>
    );
}
